// @ts-nocheck
/**
 * afc-enhanced-conversions.js — lightweight Google Ads enhanced conversions bridge.
 *
 * Keeps buyer-safe first-party identifiers normalized in memory and applies
 * them to the Google tag when available. This avoids relying on DOM scraping
 * or on recipient shipping fields that do not belong to the purchaser.
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  var state = hydrateState();

  function hydrateState() {
    var next = {};

    try {
      next.email = normalizeEmail(localStorage.getItem('aiflorist_marketing_email'));
      next.firstName = normalizeName(localStorage.getItem('aiflorist_marketing_first_name'));
      next.lastName = normalizeName(localStorage.getItem('aiflorist_marketing_last_name'));

      var rawDraft = localStorage.getItem('aiflorist_afc_cart_delivery_draft');
      if (rawDraft) {
        var draft = JSON.parse(rawDraft);
        if (draft && typeof draft === 'object') {
          if (!next.email) next.email = normalizeEmail(draft.senderEmail);
          if (!next.firstName) next.firstName = normalizeName(draft.senderFirstName);
          if (!next.lastName) next.lastName = normalizeName(draft.senderLastName);
          next.phoneNumber = normalizePhone(draft.senderPhone);
        }
      }
    } catch (_err) {
      // Fail closed — enhanced conversions must never block storefront flows.
    }

    return stripEmpty(next);
  }

  function rememberBuyerProfile(profile) {
    if (!profile || typeof profile !== 'object') return getUserData();

    var normalized = stripEmpty({
      email: normalizeEmail(profile.email),
      phoneNumber: normalizePhone(
        profile.phoneNumber || profile.phone || profile.senderPhone
      ),
      firstName: normalizeName(profile.firstName),
      lastName: normalizeName(profile.lastName),
    });

    if (normalized.email) state.email = normalized.email;
    if (normalized.phoneNumber) state.phoneNumber = normalized.phoneNumber;
    if (normalized.firstName) state.firstName = normalized.firstName;
    if (normalized.lastName) state.lastName = normalized.lastName;

    applyToGoogleTag();
    return getUserData();
  }

  function getUserData() {
    var userData = {};
    if (state.email) userData.email = state.email;
    if (state.phoneNumber) userData.phone_number = state.phoneNumber;
    return userData;
  }

  function applyToGoogleTag() {
    var userData = getUserData();
    if (!Object.keys(userData).length) return false;
    if (typeof window.gtag !== 'function') return false;

    try {
      window.gtag('set', 'user_data', userData);
      return true;
    } catch (_err) {
      return false;
    }
  }

  function normalizeEmail(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (!normalized || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) return '';
    return normalized;
  }

  function normalizePhone(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    var digits = raw.replace(/[^\d]/g, '');
    if (!digits) return '';

    if (raw.charAt(0) === '+') {
      return /^\+\d{11,15}$/.test('+' + digits) ? '+' + digits : '';
    }
    if (digits.length === 8) {
      return '+65' + digits;
    }
    if (digits.indexOf('65') === 0 && digits.length === 10) {
      return '+' + digits;
    }
    if (digits.length >= 11 && digits.length <= 15) {
      return '+' + digits;
    }
    return '';
  }

  function normalizeName(value) {
    var normalized = String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
    return normalized || '';
  }

  function stripEmpty(input) {
    var next = {};
    if (!input || typeof input !== 'object') return next;

    for (var key in input) {
      if (!Object.prototype.hasOwnProperty.call(input, key)) continue;
      if (input[key]) next[key] = input[key];
    }
    return next;
  }

  window.AIFlorist.enhancedConversions = {
    rememberBuyerProfile: rememberBuyerProfile,
    getUserData: getUserData,
    applyToGoogleTag: applyToGoogleTag,
    state: state,
  };

  applyToGoogleTag();
})();
